import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';

// components
import { BroadbandBanner } from '../components/banner';
import { CheckYourAddress } from '../components/check-your-address';
import { ChoosePlan } from '../components/choose-plan';
import { Promo } from '../components/promotions/promo';
import { Reviews } from '../components/promotions/testimonials';
import { Faq } from '../components/faq';
import {
  FirstMonthBannerConfig,
  FirstMonthOffer,
  SpeedShowCase,
  MarketingInfo,
  NotificationManager,
} from '@sky-tv-group/components';

import { configService, addressService, prequalService } from '../services';

import { useStore } from '../store';
import { useAuth0 } from '../auth0/store';
import {
  SPLITIO_KEY,
  useJSONConfig,
  useSplitIO,
  useProductStore,
  telPhoneNumber,
  UserGroupType,
  useGetWifiGuyRecommendations,
  combineAddressArray,
  formatAddress,
  bbNamesOld,
  bbNamesNew,
  unformattedTelPhoneNumber,
  BACKEND_ENDPOINT,
} from '@sky-tv-group/shared';
import { Permission } from '../components/permission';
import { myAccountSWR } from '../swr';
import { DOMAIN } from '../config';
import SsnBroadbandBanner from '../components/banner/SsnBroadbandBanner';

const Home = () => {
  const { selectedIsSkyStarterCustomer } = useStore();
  const {
    setSelectedTuiAddress,
    setGuestPrequal,
    setSelectedInstallationAddress,
    setUseGuestPrequal,
    setSelectedAddressId,
  } = useStore();
  const { wifiGuySelectedAddressId } = useGetWifiGuyRecommendations();

  const { hasActiveOrPendingBroadbandPackage } = useStore();
  const { setSelectedIsSkyStarterCustomer } = useStore();
  const { setProductStoreCartTypeUpgrade } = useProductStore();
  const { hasPriceHoldCampaign } = myAccountSWR.usePackages();
  const { isAuthenticated } = useAuth0();

  const marketingInfoRef = useRef<HTMLInputElement>(null);

  const search = useLocation().search;
  const urlSearchParams = new URLSearchParams(search);
  const section = urlSearchParams.get('section');
  const isSsnCustomer = isAuthenticated ? false : urlSearchParams.get('ssn') === 'true';

  const [shouldShowOneMonthBanner] = useSplitIO(SPLITIO_KEY.SKYWEB_ONE_MONTH_ON_US);
  const [shouldShowBBPromoVideo] = useSplitIO(SPLITIO_KEY.SKYWEB_BB_TVC);
  const [broadbandNewpriceEnabled] = useSplitIO(SPLITIO_KEY.SKYWEB_BROADBAND_NEWPRICE);
  const [showBbBanner] = useSplitIO(SPLITIO_KEY.SKYWEB_BB_INFO_BANNER);
  const config = useJSONConfig(configService);
  const firstMonthBannerConfig: FirstMonthBannerConfig =
    config?.broadband?.acquisition?.firstMonthBannerConfigWithoutTitle;

  let priceOverride: string | undefined;
  if (hasPriceHoldCampaign || !broadbandNewpriceEnabled) {
    priceOverride = `$${bbNamesOld.broadbandWifi100.price1}.00`;
  } else {
    priceOverride = `$${bbNamesNew.broadbandWifi100.price1}.00`;
  }

  useEffect(() => {
    async function prequalify(addressId: string) {
      try {
        const prequal = await prequalService.getPrequalDetails(addressId);

        setSelectedTuiAddress(addressId);

        if (prequal) {
          setGuestPrequal(prequal);
        }
      } catch (err) {
        console.log('prequalify error', err);
      }
    }

    async function getAddressDetails() {
      //Set address details from the selected Address ID
      if (wifiGuySelectedAddressId) {
        const addressDetails = await addressService.getAddressDetail(wifiGuySelectedAddressId);
        const tui = get(addressDetails, 'references.tui', undefined);

        const formattedAddress = combineAddressArray([
          addressDetails.formatted_delivery_address?.line1,
          addressDetails.formatted_delivery_address?.line2,
          addressDetails.formatted_delivery_address?.line4,
          addressDetails.formatted_delivery_address?.line4,
        ]);
        const addressLines = formatAddress(
          addressDetails.formatted_delivery_address.line1,
          addressDetails.formatted_delivery_address.line2,
          addressDetails.formatted_delivery_address.line3,
          addressDetails.formatted_delivery_address.line4
        );

        setSelectedInstallationAddress(formattedAddress.toUpperCase(), addressLines);
        setSelectedAddressId(addressDetails.references.id);
        setUseGuestPrequal(true);
        prequalify(tui);
      }
    }
    getAddressDetails();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    async function prequalify(addressId: string) {
      try {
        const prequal = await prequalService.getPrequalDetails(addressId);

        setSelectedTuiAddress(addressId);

        if (prequal) {
          setGuestPrequal(prequal);
        }
      } catch (err) {
        console.log('prequalify error', err);
      }
    }

    async function getAddressDetails() {
      //Set address details from the selected Address ID
      if (wifiGuySelectedAddressId) {
        const addressDetails = await addressService.getAddressDetail(wifiGuySelectedAddressId);
        const tui = get(addressDetails, 'references.tui', undefined);

        const formattedAddress = combineAddressArray([
          addressDetails.formatted_delivery_address?.line1,
          addressDetails.formatted_delivery_address?.line2,
          addressDetails.formatted_delivery_address?.line4,
          addressDetails.formatted_delivery_address?.line4,
        ]);
        const addressLines = formatAddress(
          addressDetails.formatted_delivery_address.line1,
          addressDetails.formatted_delivery_address.line2,
          addressDetails.formatted_delivery_address.line3,
          addressDetails.formatted_delivery_address.line4
        );

        setSelectedInstallationAddress(formattedAddress.toUpperCase(), addressLines);
        setSelectedAddressId(addressDetails.references.id);
        setUseGuestPrequal(true);
        prequalify(tui);
      }
    }
    getAddressDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    switch (section) {
      case 'marketinginfo':
        if (marketingInfoRef && marketingInfoRef.current) {
          window.scrollTo(0, marketingInfoRef.current.offsetTop - 25);
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [marketingInfoRef]);

  useEffect(() => {
    setSelectedIsSkyStarterCustomer(isSsnCustomer ? false : true);
    setProductStoreCartTypeUpgrade(isSsnCustomer ? false : true);

    // setSelectedIsSkyStarterCustomer(isAuthenticated ? true : customer === 'y');

    // /* Make isSkyStarterCustomer behaviour consistent with analytics. */
    // setProductStoreCartTypeUpgrade(isAuthenticated ? true : customer === 'y');

    // eslint-disable-next-line
  }, [isAuthenticated, isSsnCustomer]);

  return (
    <div className={isSsnCustomer ? 'bg-primary-white' : 'bg-neutral-off-white'}>
      <div>
        <div className="relative">
          {!hasActiveOrPendingBroadbandPackage &&
            (isSsnCustomer ? (
              <SsnBroadbandBanner />
            ) : (
              <BroadbandBanner priceOverride={priceOverride} isSsnCustomer={isSsnCustomer} />
            ))}
          {/* <div className="md:flex  md:container md:mx-auto md:relative"> */}
          <CheckYourAddress isSsnCustomer={isSsnCustomer} />
          {/* </div> */}
        </div>

        {isSsnCustomer && (
          <>
            <div className="max-w-3xl mx-auto mt-12 px-4">
              <h4 className="sky-h4-black mb-6">To claim your Sky Broadband special offer:</h4>

              <ol className="list-decimal pl-6 space-y-3 text-lg text-black sky-h5-reg">
                <li>Enter your address above to check for fibre availability.</li>
                <li>Choose your plan below.</li>
                <li>
                  Complete the sign-up process and enter the code
                  <span className="font-semibold"> SSNBROADBAND </span> at checkout.
                </li>
                <li>
                  <a href="https://www.sky.co.nz/broadband" rel="noopener noreferrer">
                    Visit Sky Broadband to see our full range of plans
                  </a>
                </li>
              </ol>
            </div>{' '}
          </>
        )}

        <Permission excludes={[UserGroupType.SKY_VTV_CUSTOMER]}>
          <ChoosePlan />
          {shouldShowOneMonthBanner && !selectedIsSkyStarterCustomer && (
            <FirstMonthOffer
              infoConfig={firstMonthBannerConfig}
              className={'container m-auto pb-10 px-4 md:px-0 md:pb-13'}
            />
          )}
        </Permission>

        {!isSsnCustomer && (
          <Permission includes={[UserGroupType.SKY_VTV_CUSTOMER]}>
            <div className="container c-container m-auto py-4">
              <h4 className="bg-neutral-off-white text-primary-mid-night text-center h-24 flex justify-center items-center font-skyBold">
                Call&nbsp;<a href={`tel:${telPhoneNumber}`}> {telPhoneNumber} to Get Sky Broadband Now.</a>
              </h4>
            </div>
          </Permission>
        )}

        {showBbBanner && !isSsnCustomer && (
          <div className="bg-primary-white">
            <div className="md:container mx-auto">
              <SpeedShowCase data={config?.broadband?.acquisition?.speedShowCase} />
            </div>
          </div>
        )}
        {/* This element is to focus here when section = 'MarketingInfo' */}
        <div ref={marketingInfoRef}></div>
        {!isSsnCustomer && <MarketingInfo />}
        {!isSsnCustomer && <Reviews />}
        {/* Was asked to be removed in WEB-2275 */}
        {/* <LatestTech /> */}
        {shouldShowBBPromoVideo && !isSsnCustomer ? (
          <div className=" flex justify-center w-full  overflow-hidden min-w-0 bg-primary-white">
            <Promo />
          </div>
        ) : (
          ''
        )}

        {!isSsnCustomer && <Faq filter={'Marketing'} title={"FAQ's"} />}
      </div>
    </div>
  );
};

export { Home };
